import http from '../../utils/Http/Http'

type DeleteScheduleResponse = {
	message: string
}

export async function deleteSchedule(scheduleName: string): Promise<DeleteScheduleResponse> {
	const response = await http({
		url: `/scheduler/schedule/${scheduleName}`,
		method: 'delete',
	})

	return response.data
}
